import React from "react";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import { Space } from "../space/Space";

export interface IEmptyStateProps {
    message?: string;
}

export const EmptyState: React.FC<IEmptyStateProps> = ({ message }) => {
    return (
        <Column alignmentHorizontal={"center"} width={"100%"}>
            <Space size={"xxs"} />
            <Text type={"h300"}>{message}</Text>
        </Column>
    );
};
